<template>
    <div class="expand-flex">
        <div class="expand-flex-main">
            <infinite-widget
                :preview="preview"
                v-for="(value, index) in values"
                :key="name + '-' + index"
                :id="name + '-' + index"
                v-bind="$attrs"
                v-model="values[index]"
                :apisearch="apisearch"
                :extraParams="extraParams"
                :name="name"
                :required="required"
                :map="map"
                @blur="$emit('blur')"
                :displayCode="displayCode"
            />
        </div>
        <div class="expand-flex-side" v-if="!preview">
            <div
                class="side-button-wrapper"
                :class="{
                    disabled: this.hasValues() !== this.count || (this.maxfields > 0 && this.count >= this.maxfields),
                }"
            >
                <button
                    type="button"
                    :disabled="this.hasValues() !== this.count || (this.maxfields > 0 && this.count >= this.maxfields)"
                    class="side-button"
                    v-on:click="openNew()"
                >
                    <div class="image-wrapper">+</div>
                    Lägg till {{ name }}
                </button>
            </div>
            <div
                class="side-button-wrapper"
                v-for="(value, index) in values"
                :key="name + '-img-' + index"
                :style="index === 0 ? 'display: none' : ''"
            >
                <button type="button" @click="removeItem(index)" class="side-button">
                    <img src="@/assets/delete.svg" />Radera fält
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import linkEvents from "@/linkEvents";
import InfiniteWidget from "./InfiniteWidget.vue";
export default {
    name: "ExpandableInfiniteWidget",
    components: {
        InfiniteWidget,
    },
    props: {
        optionalArgs: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        name: String,
        required: Boolean,
        maxlength: String,
        maxfields: {
            type: Number,
            required: false,
            default: 0,
        },
        apisearch: String,
        extraParams: Object, // An object specifying additional parameters to be passed to backend, such as filters
        value: undefined, // Should be Object, but can be Number until backend catches up
        displayCode: Boolean, // if code should be shown or not
        /**
         * In case the data from backend is NOT a JSON object with the format
         * { id, code, displayName }, a map Function must be supplied by the parent
         */
        map: {
            type: Function,
            default: (item) => {
                return {
                    id: item.id,
                    code: item.code,
                    displayName: item.displayName,
                };
            },
        },
        preview: Boolean,
    },
    data: function () {
        return {
            values: [""],
            objectValues: [],
            count: 1,
        };
    },
    methods: {
        hasValues() {
            const newArr = this.values.filter((item) => item != "");
            return newArr.length;
        },
        async openNew(value = "") {
            this.values.push(value);
            this.count += 1;
            const input = await this.focusInput();
            input.focus();
        },
        async focusInput() {
            let string = `#${this.name}-${this.hasValues()}`;
            await this.$nextTick();
            const listOfEl = document.querySelectorAll(string);
            await this.$nextTick();
            return listOfEl[1];
        },
        removeItem(index) {
            document.activeElement.blur();
            if (this.values.length > 1) {
                this.values.splice(index, 1);
            }
            this.count -= 1;
        },
        updateAndEmitObjectValues(event, index) {
            this.objectValues[index] = event;
            this.$emit("update", this.objectValues);
        },
        objectIsNotEmpty(obj) {
            return Object.keys(obj).length !== 0;
        },
    },
    watch: {
        value() {
            this.values = this.value.length ? this.value : [""];
            this.count = this.value.length ? this.value.length : 1;
        },
        values() {
            const hasEmpptyValues = Boolean(this.values.filter((item) => typeof item === "number").length);

            if (this.objectIsNotEmpty(this.optionalArgs)) {
                const { ErrorMessage, noDuplicates } = this.optionalArgs;
                if (noDuplicates === true) {
                    const uniqueValues = new Set(this.value.map((v) => v));
                    if (uniqueValues.size < this.value.length && !hasEmpptyValues !== true) {
                        linkEvents.$emit(this.name + "_error", ErrorMessage);
                        linkEvents.$emit(this.name + "_focus", true);
                    } else {
                        linkEvents.$emit(this.name + "_error", null);
                        linkEvents.$emit(this.name + "_focus", false);
                    }
                }
            }

            this.$emit("input", this.values);
        },
    },
};
</script>

<style lang="sass" scoped>
.expand-flex
    display: flex

.expand-flex-main
    flex-grow: 1

    div:not(:last-of-type)
        margin-bottom: 10px

.expand-flex-side
    flex-grow: 0

.side-button-wrapper
    height: 46px
    line-height: 46px
    display: block
    padding-top: 2px
    padding-bottom: 12px
    padding-left: 10px

    &:not(:last-of-type)
        margin-bottom: 10px

    &:first-of-type
        padding-left: 20px

    .side-button
        border: none
        white-space: nowrap
        font-family: Roboto Medium
        color: black
        border-radius: 4px
        background-color: inherit
        height: 38px
        line-height: 32px

        &:hover:not([disabled])
            background-color: #CEE9F3

        .image-wrapper
            display: inline-block
            width: 28px
            height: 28px
            line-height: 28px
            border-radius: 14px
            background-color: #38A7CF
            color: white
            margin-right: 8px

        img
            margin-top: -6px
            margin-right: 8px

.disabled
    opacity: 0.3
</style>
